import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GalleryTitle from 'components/Components/Sections/Gallery/GalleryTitle';
import GalleryImages from 'components/Components/Sections/Gallery/GalleryImages';
import GalleryModal from 'components/Components/Sections/Gallery/GalleryModal';

function Gallery({
    images, element, title, withFade,
})
{
    const [state, setState] = useState({
        showModalGallery: false,
        selectedImageIndex: 0,
    });

    const handleOpenModalGallery = (imageIndex) =>
    {
        setState({ selectedImageIndex: imageIndex, showModalGallery: true });
    };

    const handleCloseModalGallery = (event) =>
    {
        event.preventDefault();
        setState({ showModalGallery: false, selectedImageIndex: -1 });
    };

    return (
        <section id="gallery" className="tw-py-10 lg:tw-py-20 tw-px-4 tw-text-center">
            <GalleryTitle title={title} />

            <GalleryImages element={element} handleOpenModalGallery={handleOpenModalGallery} images={images} withFade={withFade} />

            <GalleryModal
                handleCloseModalGallery={handleCloseModalGallery}
                images={images}
                element={element}
                showModalGallery={state.showModalGallery}
                selectedImageIndex={state.selectedImageIndex}
            />
        </section>
    );
}

Gallery.defaultProps = {
    title: 'Gallery',
    withFade: false,
};

Gallery.propTypes = {
    images: PropTypes.array.isRequired,
    element: PropTypes.string.isRequired,
    title: PropTypes.string,
    withFade: PropTypes.bool,
};

export default Gallery;
